import React, { useState } from 'react'
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai'
import { FaGithub } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";


const Navbar = () => {
    const [nav, setNav] = useState(false)

    const handleNav = () => {
        setNav(!nav)
    }
    
  return (
    <div>
        <div className='bg-black text-gray-400 h-[100px] max-w-[1200px] mx-auto flex justify-between items-center'>
            <h1 className='text-3xl font-bold primary-color ml-4'>Abdul Moeez Shaikh</h1>
            <ul className='hidden md:flex'>
                <li className='p-5'><a href='#about'>About</a></li>
                <li className='p-5'><a href='#projects'>Projects</a></li>
                <li className='p-5'><a href='#contact'>Contact</a></li>
                <li className='p-5'><a href='https://www.linkedin.com/in/abdulmoeezshaikh/'>LinkedIn <FaLinkedin className='ml-2 inline  pb-[1px]'/></a></li>
                <li className='p-5'><a href='https://github.com/moeezs'>Github <FaGithub className='ml-2 inline pb-[1px]'/></a></li>
            </ul>

            <div onClick={handleNav} className='block md:hidden mr-6'>
                {nav ? <AiOutlineClose size={20} /> : <AiOutlineMenu size={20} />}
            </div>

            {nav && <div className='fixed inset-0 bg-black/70 z-10' onClick={handleNav}></div>}

            <div className={nav ? 'z-10 fixed h-full left-0 top-0 w-[60%] bg-[#202121] ease-in-out duration-500' : 'z-10 fixed h-full left-[-100%] top-0 w-[60%] bg-[#202121] ease-in-out duration-500'}>
                <h1 className='text-3xl font-bold primary-color m-4'>Abdul Moeez Shaikh</h1>
                <ul className='p-8 text-2xl'>
                    <li className='p-4 border-b border-gray-600' onClick={handleNav}><a href='#about'>About</a></li>
                    <li className='p-4 border-b border-gray-600' onClick={handleNav}><a href='#projects'>Projects</a></li>
                    <li className='p-4 border-b border-gray-600' onClick={handleNav}><a href='#contact'>Contact</a></li>
                    <li className='p-4 border-b border-gray-600' onClick={handleNav}><a href='https://www.linkedin.com/in/abdulmoeezshaikh/'>LinkedIn <FaLinkedin className='ml-2 inline  pb-[1px]'/></a></li>
                    <li className='p-4 border-b border-gray-600' onClick={handleNav}><a href='https://github.com/moeezs'>Github <FaGithub className='ml-2 inline pb-[1px]'/></a></li>
                </ul>
            </div>
        </div>
    </div>
  )
}

export default Navbar